import * as langs from 'langs';
import {BuilderFactory} from './builder.factory';

export interface LangItem {
  name: string;
  local: string;
  BCP_47: string;
  ISO_639_1: string;
}

export class LangsUtil {
  static getLangItems(bcp47Names: string[]): LangItem[] {
      return bcp47Names.map(name => {return LangsUtil.getLangItem(name);
    });
  }

  static getLangItem(bcp47Name: string): LangItem {
    const twoCharacterName = bcp47Name ? bcp47Name.slice(0, 2) : '';
    const item = langs.where('1', twoCharacterName);
    const builder = BuilderFactory.createBuilder<LangItem>();
    builder.BCP_47(bcp47Name);
    if (!item) {
      return builder.name('').local('').ISO_639_1(twoCharacterName).build();
    }
    return builder.name(item.name).local(item.local).ISO_639_1(item['1']).build();
  }

}
